var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgPhone = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: "1em",
  height: "1em",
  viewBox: "0 0 32 32"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "m23 24.793-3.081-5.945c-.007.003-1.727.849-1.806.884-1.96.95-5.95-6.842-4.033-7.87l1.823-.897L12.846 5l-1.843.91c-6.302 3.285 3.704 22.733 10.15 19.787.107-.048 1.84-.9 1.847-.904"
})));
export default SvgPhone;